module.exports = __webpack_public_path__ + "static/media/dashboardMenuIcon.ca02e901.svg";